import React from "react";
import TimePicker from "antd/lib/time-picker";
import { TTimePicker } from "./interface";

import "./index.less";

const ZTimePicker: TTimePicker = props => (
	<TimePicker popupClassName="z-time-picker-popup" {...props} />
);

ZTimePicker.RangePicker = TimePicker.RangePicker;

export default ZTimePicker;
